/**
 * 인증된 화면 공통 shell. 상단 헤더 + 메인 + 하단 탭 네비.
 * SPEC §4, DESIGN.md Layout 참조 (모바일 1화면 1책무, 24px side margin).
 */
import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { BottomTabs } from './BottomTabs';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  trailing?: ReactNode;
}

export function PageHeader({ title, subtitle, trailing }: PageHeaderProps) {
  return (
    <header className="px-xl pt-3xl pb-lg flex items-start justify-between gap-md">
      <div className="min-w-0 flex-1">
        <h1 className="font-display text-[22px] font-medium text-[var(--text-primary)] leading-tight tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-[12px] text-[var(--text-muted)] mt-xs leading-snug">{subtitle}</p>
        )}
      </div>
      {trailing && <div className="shrink-0">{trailing}</div>}
    </header>
  );
}

export function EmptyState({ children }: { children: ReactNode }) {
  return (
    <div className="px-xl py-3xl">
      <div className="bg-[var(--surface)] border border-dashed border-[var(--border)] rounded-xl px-xl py-3xl text-center">
        <p className="text-[13px] text-[var(--text-secondary)] leading-relaxed">{children}</p>
      </div>
    </div>
  );
}

export function AppShell() {
  return (
    <div className="min-h-screen flex flex-col bg-[var(--bg)] pb-20">
      <Outlet />
      <BottomTabs />
    </div>
  );
}
